import api from "@/services/api";
import C from "@/utils/constants";

export default {
  loadMe({ commit }) {
    commit("toggleIsLoadingMe");
    return api
      .getMe()
      .then((resp) => {
        // if (resp.data.id) {
        //   set("userId", resp.data.id);
        // }
        // commit("setMe", resp.data);
        let userName = "undefined";
        if (resp.data.firstName && resp.data.lastName) {
          userName = `${resp.data.firstName} ${resp.data.lastName}`;
        } else if (resp.data.firstName) {
          userName = resp.data.firstName;
        } else if (resp.data.lastName) {
          userName = resp.data.lastName;
        }
        console.log("USER ME");
        console.log(resp.data);
        // let userRoles = resp.data.roles.map((r) => r.name).join(", ");

        // const userProperties = {
        //   dimension5: userRoles,
        // };
        // this.$gtag.set({ userProperties: userProperties });
        // this.$gtag.set("user_properties", {
        //   favorite_composer: "Mahler",
        //   favorite_instrument: "double bass",
        //   season_ticketholder: "true",
        // });
        // this.$gtag.set({
        //   user_properties: {
        //     dimension1: resp.data.id,
        //     dimension2: userName,
        //     dimension5: userRoles,
        //   },
        // });
        commit("setMe", {
          me: resp.data,
          meta: {
            analytics: [
              ["set", C.GOOGLE.USER_ID, resp.data.id],
              ["set", C.GOOGLE.USER_UUID, resp.data.id],
              ["set", C.GOOGLE.USER_NAME, userName],
              // ["set", C.GOOGLE.USER_ROLE, userRoles],
            ],
          },
        });

        commit("toggleIsLoadingMe");
        return resp;
      })
      .catch((e) => {
        commit("toggleIsLoadingMe");
        throw e;
      });
  },
  updateMe({ commit, state }, updates) {
    return api
      .updateUser(state.me.id, updates)
      .then((resp) => {
        // commit("setMe", resp.data);
        commit("setMe", {
          me: resp.data,
        });
        return resp;
      })
      .catch((e) => {
        throw e;
      });
  },
  loadMyBrokerage({ commit, state }) {
    return api
      .getBrokerage(state.me.brokerId)
      .then((resp) => {
        // this.$gtag.set({
        //   user_properties: {
        //     dimension3: resp.data.id, // BROKERAGE_ID
        //     dimension4: resp.data.name, // BROKERAGE_NAME
        //   },
        // });
        commit("setMyBrokerage", {
          brokerage: resp.data,
          meta: {
            analytics: [
              ["set", C.GOOGLE.BROKERAGE_ID, resp.data.id],
              ["set", C.GOOGLE.BROKERAGE_NAME, resp.data.name],
            ],
          },
        });
        return resp;
      })
      .catch((e) => {
        throw e;
      });
  },
  loadBoostStatus({ commit }) {
    return api
      .getBoost()
      .then((resp) => {
        let statusObj = {
          enabled: resp.data.enabled,
          percentage: resp.data.boostPercentage ? resp.data.boostPercentage : 0,
          timestamp: new Date(),
        };

        commit("setBrokerBoostStatus", statusObj);
        return resp;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },
  loadMyLoanOffice({ commit, state }) {
    return api.lender
      .getLoanOffice(state.me.loanOfficeId)
      .then((resp) => {
        commit("setMyLoanOffice", {
          loanOffice: resp.data,
          // meta: {
          //   analytics: [
          //     ["set", C.GOOGLE.BROKERAGE_ID, resp.data.id],
          //     ["set", C.GOOGLE.BROKERAGE_NAME, resp.data.name],
          //   ],
          // },
        });
        return resp;
      })
      .catch((e) => {
        throw e;
      });
  },
  loadMyAgents({ commit }) {
    return api
      .getAgents(0, 1)
      .then((r) => {
        if (r.resp && r.resp.data && r.resp.data.totalElements) {
          console.log(
            "loadMyAgents: " + JSON.stringify(r.resp.data.totalElements),
          );
          commit("setMyAgentsCount", r.resp.data.totalElements);
        }
      })
      .catch((e) => {
        throw e;
      });
  },
  unloadMe({ commit }) {
    return new Promise((resolve) => {
      // commit("setMe", { id: null, roles: [] });
      commit("setMe", {
        me: { id: null, roles: [] },
        meta: {
          analytics: [
            // ["set", C.GOOGLE.USER_ID, null],
            // ["set", C.GOOGLE.USER_UUID, null],
            // ["set", C.GOOGLE.USER_NAME, null],
            // ["set", C.GOOGLE.BROKERAGE_ID, null],
            // ["set", C.GOOGLE.BROKERAGE_NAME, null]
          ],
        },
      });

      commit("setMyBrokerage", {
        brokerage: null,
        meta: {
          analytics: [],
        },
      });

      commit("setMyAgentsCount", 0);

      commit("setAgent", null);

      resolve("unloaded me...");
    });
  },
  // removeRole({ commit, state }, role) {
  //   return new Promise((resolve) => {
  //     console.log("trim roles...");
  //     console.log(state);
  //     console.log(role);
  //     console.log(commit);
  //
  //     const me = state.me;
  //     const roles = me.roles.filter((r) => {
  //       return r.name !== role;
  //     });
  //
  //     me.roles = roles;
  //
  //     console.log("new me....");
  //     console.log(me);
  //     commit("setMe", {
  //       me: me,
  //     });
  //     console.log(state.me);
  //     resolve("removed role..");
  //   });
  // },
  maintainRole({ commit, state }, role) {
    return new Promise((resolve) => {
      console.log("trim roles...");
      console.log(state);
      console.log(role);
      console.log(commit);

      const me = state.me;
      const roles = me.roles.filter((r) => {
        return r.name === role;
      });

      me.roles = roles;

      console.log("new me....");
      console.log(me);
      commit("setMe", {
        me: me,
      });
      console.log(state.me);
      resolve("removed other roles");
    });
  },
  maintainRoleType({ commit, state }, roleType) {
    return new Promise((resolve) => {
      console.log("trim roles...");
      console.log(state);
      console.log(roleType);
      console.log(commit);

      const me = state.me;
      const roles = me.roles.filter((r) => {
        return r.type === roleType;
      });

      me.roles = roles;

      console.log("new me....");
      console.log(me);
      commit("setMe", {
        me: me,
      });
      console.log(state.me);
      resolve("removed other roles");
    });
  },
  reloadAgent({ commit, state }) {
    console.log("** reload agent");
    return api.agent
      .get(state.me.agentId)
      .then((resp) => {
        commit("setAgent", resp.data);
        console.log("******* agent reload *************");
        console.log(resp.data);
        return resp;
      })
      .catch((e) => {
        throw e;
      });

    // try {
    //   this.loading = true;
    //
    //   const { data } = await api.agent.get(this.me.agentId);
    //   this.setAgent(data);
    //
    //   this.navigateToConsole();
    // } catch (e) {
    //   console.log(e);
    //   this.alert = true;
    // } finally {
    //   this.loading = false;
    // }
  },
};
